import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartOptions } from 'chart.js';

const PIE_CHARTS = ['pie', 'doughnut'];
const BAR_CHARTS = ['bar', 'line'];

@Component({
  selector: 'app-response-chart',
  templateUrl: './response-chart.component.html',
  styleUrl: './response-chart.component.scss'
})
export class ResponseChartComponent implements OnChanges{
  @Input() input: any | undefined;
  sections: any[] = [];
  barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1.2,
    plugins: { legend: { display: false } }
   };
  pieChartOptions: ChartOptions<'pie'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
    legend: {
      display: true,
      position:'bottom'
    }
   },
   scales: {
    x: {
      display: false, // Hide X-axis
    },
    y: {
      display: false, // Hide Y-axis
    },
  },
  };
  fileData: any = [] = []

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['input']?.currentValue) {
        this.fileData = this.input;
        this.processData()
      }
    }

  processData() {
    let typeIndex = 0;

    this.sections = Object.entries(this.fileData.stats).map(([sectionKey, sectionValue]) => {
      const sections = Object.entries(sectionValue as any).map(([key, value]) => {
        if (typeof value === 'object') {
          let data: any = value;

          const chartType = this.getChartType(key);
          typeIndex++;
          const chartData = {
            labels: ['IGST', 'CGST', 'SGST'],

            datasets: [
              {
                label: 'Tax Data',
                data: [data.igst, data.cgst, data!.sgst,],
                backgroundColor: ['#5539A8', '#32CC77', '#64748B'],
              },
            ],
          };

          return {
            title: key.replace(/_/g, ' '),
            chartType: chartType,
            chartData: chartData,
            options: PIE_CHARTS.includes(chartType) ? this.pieChartOptions : this.barChartOptions
          };
        }
        return null;
      }).filter(item => item !== null);

      return { heading: sectionKey.replace(/_/g, ' '), sections };
    });

    this.sections = this.sections.filter((val: any) => val.heading != 'gstr reconciliation');
  }

  getChartType(key: string){
    //const pieChartKeys = ['books_summary'];
    //const isPieChart  = pieChartKeys.includes(sectionKey);
    const isBarChart = key.startsWith('total')
    if(isBarChart){
      return this.getRandomValue(BAR_CHARTS);
    }
    // if(isPieChart){
    //   return this.getRandomValue(PIE_CHARTS);
    // }

    // const barChartKeys = ["perfect_match_without_special_and_tolerance"];
    // const   = barChartKeys.includes(sectionKey);


    return this.getRandomValue(PIE_CHARTS);
  }

  getRandomValue(arr: string[]): string {
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
  }
}
